var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionDeniedLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "75px",
    viewBox: "0 0 58 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Privacy_Lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmptyState",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ErrorPage-noPermission",
    transform: "translate(-691.000000, -194.000000)",
    fill: "#43C8EC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Privacy_Lock",
    transform: "translate(691.000000, 194.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8,24.31 L45.8,17.16 C45.8,7.84295627 38.2470437,0.29 28.93,0.29 C19.6129563,0.29 12.06,7.84295627 12.06,17.16 L12.06,24.3 L0.14,24.3 L0.14,74.64 L57.71,74.64 L57.71,24.31 L45.8,24.31 Z M14.05,17.16 C14.05,8.94752577 20.7075258,2.29 28.92,2.29 C37.1324742,2.29 43.79,8.94752577 43.79,17.16 L43.79,24.3 L14.05,24.3 L14.05,17.16 Z M55.71,72.64 L2.14,72.64 L2.14,26.31 L55.71,26.31 L55.71,72.64 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.93,37.33 C26.5550177,37.3567611 24.5749652,39.154747 24.319954,41.5161505 C24.0649429,43.8775541 25.6154871,46.0568139 27.93,46.59 L27.93,62.54 L29.93,62.54 L29.93,46.6 C32.2445129,46.0668139 33.7950571,43.8875541 33.540046,41.5261505 C33.2850348,39.164747 31.3049823,37.3667611 28.93,37.34 L28.93,37.33 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionDeniedLock);
export default __webpack_public_path__ + "static/media/permission-denied-lock.16036747d57cd663d7df223781a447b2.svg";
export { ForwardRef as ReactComponent };